export default __webpack_public_path__ + "static/media/start-camp-ico.bdba72bf.svg";